export enum CurrencyTypeEnum {
  BITCOIN = 'BTC',
  ETHEREUM = 'ETH',
  SOL = 'SOL_USDC',
  XRP = 'XRP_USDC',
  AVAX_USDC = 'AVAX_USDC',
  TRX_USDC = 'TRX_USDC',
  HYPE = 'HYPE_USDC',
}

export type VolSurfaceToken = string;

export function getCurrencyName(type: CurrencyTypeEnum): string {
  switch (type) {
    case CurrencyTypeEnum.BITCOIN:
      return 'Bitcoin';
    case CurrencyTypeEnum.ETHEREUM:
      return 'Ethereum';
    case CurrencyTypeEnum.SOL:
      return 'Solana';
    case CurrencyTypeEnum.XRP:
      return 'Ripple';
    case CurrencyTypeEnum.AVAX_USDC:
      return 'Avalanche';
    case CurrencyTypeEnum.TRX_USDC:
      return 'Tron';
    case CurrencyTypeEnum.HYPE:
      return 'Hyperliquid';
  }
}
